import customSitesTpl from '../templates/partners/custom_sites.directive.html';

export default function strCustomSites() {
  return {
    restrict: 'EA',
    template: customSitesTpl,
    controller: 'CustomSitesController',
    controllerAs: 'sitesVm',
    bindToController: true,
    scope: {
      partner: '='
    }
  };
}
